import { Reveal } from "@/components/Reveal";

const COLS = [
  [
    { id: "fianco", lead: "Al vostro fianco da sempre:", text: "radici solide nelle scuole grazie alle agenzie editoriali storiche del territorio. Parliamo la vostra lingua." },
    { id: "gratuito", lead: "Accesso 100% Gratuito:", text: "l'istruzione non deve avere barriere. Nessun costo nascosto." },
  ],
  [
    { id: "burocrazia", lead: "Oltre la burocrazia:", text: "portale diretto con le migliori aziende, pronte ad accogliere le classi." },
    { id: "orientamento", lead: "Orientamento reale:", text: "per scoprire il vero potenziale dei ragazzi, superando il semplice voto in pagella." },
  ],
];

export const PercheIstituti = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="istituti-perche-section">
    <div className="max-w-6xl mx-auto">
      <Reveal className="text-center mb-16 lg:mb-24">
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl">Perché scegliere Prodigy?</h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-12">
        {COLS.map((col, ci) => (
          <div key={ci} className="space-y-12">
            {col.map(({ id, lead, text }, i) => (
              <Reveal key={id} delay={ci * 120 + i * 80}>
                <div className="border-t border-[#1e2024] pt-8 max-w-[52ch]" data-testid={`istituti-perche-${id}`}>
                  <p className="text-lg sm:text-xl leading-relaxed text-titanium">
                    <strong className="block mb-2 font-bold text-white text-xl sm:text-2xl tracking-[-0.02em]">{lead}</strong>
                    {text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
